import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  getDefaults,
  putDefaults,
  getEngineSettings,
  putTranscribeConfig,
} from '../services/settingsApi'

export function useDefaults() {
  return useQuery({
    queryKey: ['settings', 'defaults'],
    queryFn: getDefaults,
    staleTime: 60 * 1000,
  })
}

export function useSaveDefaults() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: putDefaults,
    onSuccess: (data) => qc.setQueryData(['settings', 'defaults'], data),
  })
}

export function useEngineSettings() {
  return useQuery({
    queryKey: ['settings', 'engines'],
    queryFn: getEngineSettings,
    staleTime: 30 * 1000,
  })
}

export function useSaveTranscribeConfig() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: putTranscribeConfig,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['settings', 'engines'] }),
  })
}
